class RangeSlider {
	constructor(selector, options = {}) {
		this.container = document.querySelector(selector);
		if(!this.container) return;
		this.slider = this.container.querySelector('[data-range-slider]');
		this.progress = this.container.querySelector('[data-range-progress]');
		this.thumb = this.container.querySelector('[data-range-thumb]');
		this.tooltip = this.container.querySelector('[data-range-tooltip]');
		this.min = options.min || this.slider.getAttribute('min') || 0;
		this.max = options.max || this.slider.getAttribute('max') || 100;
		this.step = options.step || this.slider.getAttribute('step') || 0;
		this.value = options.value || this.slider.value || 0;
		this.onSlide = options.onSlide || function () {};
		this.onSlideEnd = options.onSlideEnd || function () {};
		this.onInit = options.onInit || function () {};

		this.slider.min = this.min;
		this.slider.max = this.max;
		this.slider.step = this.step;
		this.slider.value = this.value;

		document.addEventListener('DOMContentLoaded', this.initial.bind(this));
		this.slider.addEventListener('input', this.actionSlide.bind(this));
		this.slider.addEventListener('change', this.actionSlideEnd.bind(this));
	}

	action() {
		this.val = (this.slider.value - this.slider.min) / (this.slider.max - this.slider.min) * 100;
		this.tooltip.innerHTML = this.slider.value;
		this.thumb.style.left = `${this.val}%`;
		this.thumb.style.transform = `translate(-${this.val}%, -50%)`;
		this.progress.style.width = `${this.val}%`;
	}

	initial() {
		this.action();
		this.onInit(
			this.slider.value,
			this.slider.step,
			this.slider.max,
			this.slider.min,
		);
	}

	actionSlide() {
		this.action();
		this.onSlide(
			this.slider.value,
			this.slider.step,
			this.slider.max,
			this.slider.min,
		);
	}

	actionSlideEnd() {
		this.onSlideEnd(this.slider.value);
	}

	setValue(value) {
		this.slider.value = value;
	}

	getValue() {
		return this.slider.value;
	}

	setMin(min) {
		this.slider.min = min;
	}

	getMin() {
		return this.slider.min;
	}

	setMax(max) {
		this.slider.max = max;
	}

	getMax() {
		return this.slider.max;
	}

	setStep(step) {
		this.slider.step = step;
	}

	getStep() {
		return this.slider.step;
	}

	setOnSlide(onSlide) {
		this.onSlide = onSlide;
	}

	setOnSlideEnd(onSlideEnd) {
		this.onSlideEnd = onSlideEnd;
	}
}

export default RangeSlider;

// new RangeSlider('[data-range-container]', {
// 	value: 1,
// 	min: 1,
// 	max: 30,
// 	step: 0.5,
// 	onInit: (value, step, max, min) => {
// 		// let lines = document.querySelectorAll('.ranges-area .range-line');
// 		// let count = 1;
// 		// lines.forEach((el, index) => {
// 		// 	let position = (count - min) / (max - min) * 100;
// 		// 	el.style.left = `calc(${position}%)`;
// 		// 	el.style.transform = `translateX(-${position}%)`;
// 		// 	count = count + 3 * 0.5;
// 		// })
// 	}
// });

